module.exports = __webpack_public_path__ + "img/z-company.23c3a609.jpg";